import React from "react";
import { toast } from "react-toastify";
import { AlertTriangle } from "lucide-react";

const ToastWarning = (heading: string, messages: string) => {
  toast(
    <div style={{ width: 380 }}>
      <div
        style={{ fontSize: "14px", background: "#FEE2E2" }}
        className="d-flex align-items-center gap-2 px-2 py-1"
      >
        <AlertTriangle className="text-danger" size={16} />
        <span className="text-danger fw-bold">{heading || "Error"}</span>
      </div>
      <div
        style={{
          fontSize: "14px",
          lineHeight: "150%",
          color: "#DC2626",
          background: "white",
        }}
        className="px-2 py-2"
      >
        {Array.isArray(messages) ? (
          messages.map((msg, i) => <div key={i}>{msg}</div>)
        ) : (
          <div>{messages}</div>
        )}
      </div>
    </div>,
    { autoClose: 4000, hideProgressBar: true }
  );
};

export default ToastWarning;
